import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { InputToggleWrapper, Input } from './styled';
import { Edit } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';

class InputToggle extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isEditable: false,
            title: ''
        };
        this.handleOnUpdate = this.handleOnUpdate.bind(this);
        this.handleInputLostFocus = this.handleInputLostFocus.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnKeyPress = this.handleOnKeyPress.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({ title: props.name });
    }

    handleOnUpdate() {
        this.nameInput.focus();
        this.setState({ isEditable: true });
    }

    handleInputLostFocus() {
        this.setState({ isEditable: false });
    }

    handleOnChange(e) {
        this.setState({ title: e.target.value });
        this.props.getInputValue({ id: e.target.id, name: e.target.value });
    }

    handleOnKeyPress(e) {
        if (e.key === 'Enter') {
            this.handleInputLostFocus();
            e.target.blur();
            this.props.getInputValue({ id: e.target.id, name: this.state.title });
        }
    }

    render() {
        const { placeHolder, id, name } = this.props;
        return (
            <InputToggleWrapper title={name || this.state.title}>
                <div
                    className="icon"
                    onClick={this.handleOnUpdate}
                    role="button"
                    tabIndex="-1">
                    <SvgIcon icon={Edit} />
                </div>
                <Input
                    id={id}
                    isEditable={this.state.isEditable}
                    onBlur={this.handleInputLostFocus}
                    onChange={this.handleOnChange}
                    onFocus={this.handleOnUpdate}
                    onKeyPress={this.handleOnKeyPress}
                    placeholder={placeHolder}
                    ref={(input) => { this.nameInput = input; }}
                    type="text"
                    value={name || this.state.title}
                />
            </InputToggleWrapper>
        );
    }
}

InputToggle.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string,
        PropTypes.number]),
    getInputValue: PropTypes.func,
    name: PropTypes.string,
    placeHolder: PropTypes.string
};

InputToggle.defaultProps = {
    name: ''
};

export default InputToggle;



// WEBPACK FOOTER //
// ./app/components/input-toggle/index.js